var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_9544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4688 14.1919C10.3438 14.3168 10.1743 14.387 9.99761 14.387C9.82087 14.387 9.65138 14.3168 9.52639 14.1919L8.46931 13.1348C8.34436 13.0098 8.27417 12.8403 8.27417 12.6636C8.27417 12.4868 8.34436 12.3173 8.46931 12.1924L12.1924 8.46927C12.3174 8.34432 12.4869 8.27412 12.6636 8.27412C12.8404 8.27412 13.0099 8.34432 13.1348 8.46927L14.1919 9.52634C14.3169 9.65133 14.3871 9.82083 14.3871 9.99756C14.3871 10.1743 14.3169 10.3438 14.1919 10.4688L10.4688 14.1919Z",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9971 8.66456L11.0806 4.08301C11.0557 3.95836 10.9957 3.84344 10.9076 3.7518C10.8195 3.66016 10.707 3.59562 10.5834 3.5658L2.15614 1.35167C2.04512 1.32483 1.92907 1.32697 1.81911 1.35789C1.70915 1.3888 1.60899 1.44746 1.52822 1.52822C1.44746 1.60899 1.3888 1.70915 1.35789 1.81911C1.32697 1.92907 1.32483 2.04512 1.35167 2.15614L3.5658 10.5834C3.59562 10.707 3.66016 10.8195 3.7518 10.9076C3.84344 10.9957 3.95836 11.0557 4.08301 11.0806L8.66456 11.9971",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.53296 1.53296L6.38911 6.38911",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33154 8.66455C8.06774 8.66455 8.66455 8.06774 8.66455 7.33154C8.66455 6.59534 8.06774 5.99854 7.33154 5.99854C6.59534 5.99854 5.99854 6.59534 5.99854 7.33154C5.99854 8.06774 6.59534 8.66455 7.33154 8.66455Z",
    stroke: "#057DCD",
    strokeWidth: 1.33301,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_9544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9961,
    height: 15.9961,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.668fd54a96c47675e390c734eb5ad417.svg";
export { ForwardRef as ReactComponent };